import translate from 'components/hoc/translate';
import CopyToClipboard from './paymentLink/CopyToClipboard';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { createTransactionPayment } from 'store/actions/transactions/createTransactions';
import configHelper from 'helpers/config';
import theme from 'theme/theme';
import MailTo from './paymentLink/MailTo';
import PropTypes from 'prop-types';
import { getSelectedQuote } from 'store/reducers/transactionsReducer';

const styles = {
    box: {
        display: 'block',
        backgroundColor: theme.palette.mossGreen,
        border: `1px solid ${ theme.palette.springRain }`,
    },
    container: {
        display: 'block',
        width: '700px',
        margin: '50px 0 20px 0',

    },
    content: {
        display: 'block',
        padding: '30px 20px',
        minHeight: '125px',
        wordWrap: 'break-word',
    },
    links: {
        display: 'block',
        textAlign: 'right',
    },
    message: {
        margin: '10px 0 0 0',
    },
    title: {
        margin: '0 0 5px 0',
    },
    value: {
        fontSize: '13px',
    },
};

class TransactionPaymentLinkContainer extends Component {
    constructor() {
        super();

        this.redirectUrl = configHelper.getMobianPaymentRedirectPage();
    }

    componentDidMount() {
        const {
            createPaymentLink,
            link,
            selectedQuote,
            transactionId,
        } = this.props;

        if (!link) {
            createPaymentLink(transactionId, selectedQuote.hash, this.redirectUrl);
        }
    }

    componentDidUpdate() {
        const {
            dispatchLoaderOff,
            link,
            loading,
        } = this.props;

        if (loading && link) {
            return dispatchLoaderOff();
        }
    }

    render() {
        const {
            booking,
            bookingId,
            dispatchMessage,
            link,
            prices,
            selectedQuote,
            translate,
        } = this.props;

        if (!link) {
            return null;
        }

        return (
            <div style={ styles.container }>
                <h3 style={ styles.title }>{ translate('resources.bookings.amend.phase.paymentLink', {
                    title: selectedQuote.title,
                    method: selectedQuote.payment_method,
                }) }</h3>

                <div style={ styles.box }>
                    <div style={ styles.links }>
                        <CopyToClipboard
                            link={ link }
                            setMessage={ (message) => {
                                return dispatchMessage(message);
                            } }
                        />
                        {
                            booking.email &&
                                <MailTo
                                    booking={ booking }
                                    bookingId={ bookingId }
                                    costs={ selectedQuote.costs }
                                    link={ link }
                                    price={ prices }
                                    title={ selectedQuote.title }
                                />
                        }
                    </div>

                    <div style={ styles.content }>
                        { link }
                    </div>
                </div>
            </div>
        );
    }
}

TransactionPaymentLinkContainer.propTypes = {
    booking: PropTypes.shape({
        email: PropTypes.string,
    }),
    bookingId: PropTypes.number.isRequired,
    createPaymentLink: PropTypes.func.isRequired,
    dispatchLoaderOff: PropTypes.func.isRequired,
    dispatchMessage: PropTypes.func.isRequired,
    link: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    prices: PropTypes.object.isRequired,
    selectedQuote: PropTypes.shape({
        costs: PropTypes.number.isRequired,
        hash: PropTypes.string.isRequired,
        payment_method: PropTypes.string,
        title: PropTypes.string.isRequired,
    }),
    transactionId: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        bookings,
        transactions: {
            link,
            quotes,
        },
    } = state;

    return {
        booking: bookings.data[props.bookingId],
        quotes: quotes,
        selectedQuote: getSelectedQuote(state),
        link: link,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const {
        dispatchLoaderOn,
        dispatchLoaderOff,
        setPhase,
    } = props;

    return {
        createPaymentLink: (transactionId, hash, redirectUrl) => {
            dispatchLoaderOn();

            setTimeout(() => {
                dispatch(createTransactionPayment({
                    transactionId: transactionId,
                    hash: hash,
                    redirectUrl: redirectUrl,
                    onError: () => {
                        setPhase('Payment');

                        return dispatchLoaderOff();
                    },
                }));
            }, 1500);
        },
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
);

export default enhance(TransactionPaymentLinkContainer);



// WEBPACK FOOTER //
// ./src/components/transaction/TransactionPaymentLinkContainer.js